/* eslint-disable no-shadow,no-param-reassign */
import _ from "lodash";

const initialState = {
  queue: [],
  nextPage: 1,
  morePages: false,
  counts: {
    nuw: 0,
    pending: 0,
    scheduled: 0,
    total: 0
  },
  interview: {},
  statusList: {
    nuw: "New",
    pending: "Pending",
    scheduled: "Scheduled in EMR",
    closed: "Closed, did not schedule",
    referred: "Referred to another provider",
    draft: "Draft"
  }
};

export const state = initialState;

export const getters = {
  queue: state =>
    _.filter(
      state.queue,
      q => q.attributes.interviewKind !== "Referral_Patient"
    ),
  patient: state => id =>
    state.queue[id] || { attributes: { referral: {}, referralDoctor: {} } },
  interview: state => state.interview,
  statusList: state => state.statusList,
  counts: state => state.counts,
  nextPage: state => state.nextPage,
  morePages: state => state.morePages
};

export const actions = {
  set({ commit }, payload) {
    commit("set", payload);
  },
  add({ commit }, payload) {
    commit("add", payload);
  },
  setCounts({ commit }, payload) {
    commit("setCounts", payload);
  },
  setInterview({ commit }, payload) {
    commit("setInterview", payload);
  },

  updatePatient({ commit }, payload) {
    commit("updatePatient", payload);
  },

  resetPage({ commit }) {
    commit("resetPage");
  }
};

export const mutations = {
  set(state, data) {
    if (state.nextPage === 1) {
      state.queue = Object.assign({}, data.queue.patientQueues);
    } else {
      state.queue = Object.assign({}, state.queue, data.queue.patientQueues);
    }

    let nextPage = 1;
    let morePages = false;
    if (_.has(data.links, "next")) {
      const matches = data.links.next.match(/page%5Bnumber%5D=(\d+)&/);
      nextPage = matches[1];
      morePages = true;
    }

    state.nextPage = nextPage;
    state.morePages = morePages;
  },
  add(state, data) {
    state.queue = Object.assign({}, state.queue, data.queue.patientQueues);
  },
  setCounts(state, counts) {
    state.counts = counts;
  },
  setInterview(state, data) {
    state.interview = data.interviewAnswers;
  },
  resetPage(state) {
    state.nextPage = 1;
  },
  updatePatient(state, data) {
    const patient = data.patientQueues[Object.keys(data.patientQueues)[0]];
    const patients = _.cloneDeep(state.queue);
    patients[patient.id] = patient;
    state.queue = patients;
  }
};
